<template>
  <div id="button-control">
    <ejs-button ref="addTaskButton"
        iconCss='icon hero-icon h-spectrum-icon hero-icon-add'
        cssClass="e-small e-round"
        :isPrimary="true" v-on:click.native="buttonClk" :title="title"></ejs-button>
    <CustomDialog ref='addTaskPage' :element='dialog.element.eleAddSpectrum' :styles='dialog.stylesSpectrumAdd' :messages='dialog.messages.addSpectrum'>
      <template v-slot:dialog-content>
        <SpectrumAddTaskDialog ref="addSpectrumTask"></SpectrumAddTaskDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import SpectrumAddTaskDialog from './SpectrumAddTaskDialog';
import CustomDialog from '../../common/CustomDialog';
import i18n from '../../../plugins/i18n.js';
import { EventBus } from '../../../plugins/eventBus';

enableRipple(true);
Vue.use(ButtonPlugin);

export default {
  name: 'OpertionHref',
  components: {
    SpectrumAddTaskDialog,
    CustomDialog
  },
  data() {
    return {
      title: this.$ts('Spectrum.ui_pt_spectrumbuild'),
      btns: {
        add: true
      },
      props: [
        'info'
      ],
      dialog: {
        stylesSpectrumAdd: {
          width: '30%',
          height: '40%',
          visible: false,
          model: true
        },
        element: {
          eleAddSpectrum: {
            target: this.$refs.OpertionHref,
            refName: 'eleAddSpectrum',
            buttonGroup: [
              { click: this.closeAddTaskPage, buttonModel: { content: this.$ts('Spectrum.ui_cancell') } },
              { click: this.createSpectrumTask, buttonModel: { content: this.$ts('Spectrum.ui_ok'), isPrimary: true } }
            ],
            title: this.$ts('Spectrum.ui_pt_spectrumbuild'),
            isClose: true
          }
        },
        messages: {
          addSpectrum: {
            title: this.$ts('Spectrum.ui_pt_spectrumbuild')
          }
        }
      }
    };
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    buttonClk(args) {
      console.log(args);
      // this.$emit('methodEnum', args);
      this.$refs.addTaskPage.show();
    },
    closeAddTaskPage() {
      this.$refs.addTaskPage.clear();
      this.$refs.addTaskPage.close();
    },
    createSpectrumTask() {
      const This = this;
      // 后台拼装neid带过来
      const cellid1 = This.$refs.addTaskButton.$parent.$data.data.cellid;
      const neid1 = This.$refs.addTaskButton.$parent.$data.data.neId;
      const durationValue1 = This.$refs.addSpectrumTask.getData().durationValue;
      const cycleValue = This.$refs.addSpectrumTask.$children[1].getSelectedValue();
      const params = {
        duration: durationValue1,
        timer: cycleValue,
        neid: neid1,
        cellid: cellid1
      };
      const spectrum = {
        spectrum: params
      };
      this.$axios.post('/lte/ems/spectrum/createSpectrumTask.html', params).then((response) => {
        this.closeAddTaskPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.loadSpectrumTaskList();
            EventBus.$emit('toast', { type: 'success', content: this.$ts('Common.tips.success') });
          } else {
            // this.$layer.alert({ msg: this.$ts('Spectrum.6901') });
            // EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
            if ("6900,6901,6902,6903,6906,6907,6908,6909,6910,6911,6912".includes(response.data.errorCode)) {
              EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          }
        }
      });
    },
    loadSpectrumTaskList() {
      /* const This = this;
      This.$refs.addTaskButton.click();// 用于触发bscelltable行点击为了重新加载扫频任务
      This.closeAddTaskPage(); */
      EventBus.$emit('spectrumTaskRefresh', 'refresh');
    }
  }
};
</script>
